var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phosphor/Monochrome/MapPin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5 8.26367C14.5729 8.26367 13.6666 8.53859 12.8958 9.05366C12.1249 9.56873 11.5241 10.3008 11.1693 11.1573C10.8145 12.0139 10.7217 12.9564 10.9026 13.8657C11.0834 14.7749 11.5299 15.6102 12.1854 16.2657C12.841 16.9213 13.6762 17.3677 14.5855 17.5486C15.4948 17.7295 16.4373 17.6366 17.2938 17.2819C18.1504 16.9271 18.8824 16.3263 19.3975 15.5554C19.9126 14.7846 20.1875 13.8783 20.1875 12.9512C20.1875 11.708 19.6936 10.5157 18.8146 9.63661C17.9355 8.75753 16.7432 8.26367 15.5 8.26367ZM15.5 15.7637C14.9437 15.7637 14.4 15.5987 13.9375 15.2897C13.4749 14.9806 13.1145 14.5414 12.9016 14.0275C12.6887 13.5136 12.633 12.9481 12.7415 12.4025C12.8501 11.8569 13.1179 11.3558 13.5113 10.9624C13.9046 10.5691 14.4057 10.3012 14.9513 10.1927C15.4969 10.0842 16.0624 10.1399 16.5763 10.3528C17.0902 10.5656 17.5295 10.9261 17.8385 11.3886C18.1476 11.8511 18.3125 12.3949 18.3125 12.9512C18.3125 13.6971 18.0162 14.4125 17.4887 14.9399C16.9613 15.4674 16.2459 15.7637 15.5 15.7637ZM15.5 2.63867C12.7659 2.64177 10.1447 3.72926 8.21139 5.66256C6.27809 7.59586 5.1906 10.2171 5.1875 12.9512C5.1875 16.6309 6.88789 20.5309 10.1094 24.2305C11.5569 25.9022 13.1861 27.4076 14.9668 28.7188C15.1244 28.8292 15.3122 28.8884 15.5047 28.8884C15.6971 28.8884 15.8849 28.8292 16.0426 28.7188C17.82 27.407 19.446 25.9017 20.8906 24.2305C24.1074 20.5309 25.8125 16.6309 25.8125 12.9512C25.8094 10.2171 24.7219 7.59586 22.7886 5.66256C20.8553 3.72926 18.2341 2.64177 15.5 2.63867ZM15.5 26.7793C13.5629 25.2559 7.0625 19.6602 7.0625 12.9512C7.0625 10.7134 7.95145 8.5673 9.53379 6.98496C11.1161 5.40262 13.2622 4.51367 15.5 4.51367C17.7378 4.51367 19.8839 5.40262 21.4662 6.98496C23.0486 8.5673 23.9375 10.7134 23.9375 12.9512C23.9375 19.6578 17.4371 25.2559 15.5 26.7793Z",
    fill: "url(#paint0_linear_2504_26689)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2504_26689",
    x1: 5.1875,
    y1: 28.8884,
    x2: 21.3845,
    y2: 24.6243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/MapPin.ebb642a21f06ececd3812cbc86bdb7dc.svg";
export { ForwardRef as ReactComponent };